import type { FC } from 'react'
import { memo } from 'react'

import { FormattedTimeStyled } from './styles/FormattedTimeStyled'
import { useFormatRelativeTime } from './useFormatRelativeTime'

export interface IFormattedRelativeTimeProps {
  date: Date
}

export const FormattedRelativeTime: FC<IFormattedRelativeTimeProps> = memo(
  ({ date }) => {
    const formatRelativeTime = useFormatRelativeTime()
    return <FormattedTimeStyled>{formatRelativeTime(date)}</FormattedTimeStyled>
  }
)

FormattedRelativeTime.displayName = 'FormattedRelativeTime'
